import React, { useEffect, useState } from "react";
import styles from "./CreditCardPayment.module.css";

import { GetHashCursos } from "../../utils/GeHash";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useParams } from "react-router-dom";
import { getTokenInfo } from "../../utils/Guard";
import { useDispatch, useSelector } from "react-redux";
import { GetCourse } from "../../store/course-store/course-actions";
import { GetOrdensById } from "../../store/orden-store/orden-actions";
import Loading from "../loading/Loading";

let callOnce = true;

const CreditCardPayment = ({ stepperRef }) => {
  const param = useParams();
  const userInfo = getTokenInfo();
  const dispatch = useDispatch();
  const orden = useSelector((state) => state.orden.orden);
  const course = useSelector((state) => state.course.course);
  const [amountDollar, setAmountDollar] = useState(0);
  const [amountRD, setAmountRD] = useState(0);
  const [count, setCount] = useState(1);

  useEffect(() => {
    if (orden.id === undefined || orden.id === null || orden.id === 0) {

      dispatch(GetOrdensById(userInfo.OrdenId, userInfo.Email, param.courseid));

    }
  }, [orden, userInfo, dispatch]);
  


  let amountToPay = "0";

  useEffect(() => {
    if (
      course === undefined ||
      course === null ||
      course.id === null ||
      course.id === undefined ||
      course.id === 0
    ) {
      if (
        userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== null &&
        userInfo.UserId !== undefined &&
        param.courseid !== undefined &&
        callOnce
      ) {
        callOnce = false;
        dispatch(
          GetCourse(param.courseid, userInfo.UserId, "aulaaba.aba.org.do")
        );
      } else {
        if (callOnce) {
          callOnce = false;
          dispatch(GetCourse(param.courseid, 0, "aulaaba.aba.org.do"));
        }
      }
    }
  }, [course, dispatch, param.courseid, userInfo]);

  const CancelUrl =
    process.env.REACT_APP_MERCHANTID_URL + "courseInfo/" + param.courseid;
  const ApprovedUrl =
    process.env.REACT_APP_MERCHANTID_URL + "approvedtransaction";

  const DeclinedUrl =
    process.env.REACT_APP_MERCHANTID_URL + "deniedtransaction";

  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  let moneyFormat = new Intl.NumberFormat("en-US", {
    // style: "currency",
    currency: "USD",
    useGrouping: false,
    minimumFractionDigits: 2,
  });

  useEffect(() => {
    if (
      orden &&
      orden.id !== undefined &&
      orden.id !== 0 &&
      course.id !== 0 &&
      course.id !== undefined &&
      course.id !== null
    ) {
      if (
        orden.discount &&
        orden.discount.id !== undefined &&
        orden.discount.id !== 0 &&
        count > 0
      ) {
        let discount = 0;
        if (orden.discount.percentage) {
          discount =
            course.price * count * (orden.discount.discountPercentage / 100);
        }
        if (orden.discount.nominal) {
          discount = orden.discount.discountNominal * count;
        }

        
        const dollar = course.price * count - discount;
        const rd = dollar * orden.dollarRate;
        
        setAmountDollar(dollar > 0 ? dollar : 0);
        setAmountRD(Math.round(rd > 0 ? rd : 0));
      } else {
        const dollar = course.price * count;
        const rd = Math.round(dollar * orden.dollarRate);

        setAmountDollar(dollar > 0 ? dollar : 0);
        setAmountRD(Math.round(rd > 0 ? rd : 0));
      }


    }
  }, [orden, count, course]);
  

  amountToPay = moneyFormat.format(amountRD);

  return (
    <>
      {orden.id == undefined
        && (
          <>
            <Loading />
          </>
        )}
      {orden.id > 0 && orden.id !== undefined && orden.id !== null && (
        <div>
          <h1 className={styles.formTitle}>Pago con tarjeta</h1>
          <div className={styles.facturationForm}>
            <Card className={styles.card}>
              <div className={styles.contentContainer}>
                <form className={styles.forms}>
                  <div className={styles.column}>
                    <label htmlFor="orderNumber">Número de orden</label>
                    <h1>#{orden.id}</h1>
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="orderNumber">Tasa</label>
                    <h1>{orden.dollarRate} RD$</h1>
                  </div>


                  {
                    orden.discount && orden.discount.id !== 0 && (
                      <div className={styles.column}>
                        <label htmlFor="dolarAmount">Subtotal</label>
                        <h1>{"$" + course.price + " USD"}</h1>
                      </div>
                    )
                  }

                  {
                    orden.discount && orden.discount.id !== 0 && (
                      <div className={styles.column}>
                        <label htmlFor="dolarAmount">Descuento {"(" + orden.discountCode + ")"}</label>
                        <h1>{"$" + (course.price - amountDollar).toFixed(2) + " USD"}</h1>
                      </div>
                    )
                  }

                  <div className={styles.column}>
                    <label htmlFor="dolarAmount">Monto total en dólares</label>
                    <h1>{USDollar.format(amountDollar) + " USD"}</h1>
                  </div>
                  <div className={styles.column}>
                    <label htmlFor="pesosAmount">Monto total en pesos</label>
                    <h1>{USDollar.format(amountRD)}</h1>
                  </div>
                </form>
                <icon
                  className={`pi pi-credit-card ${styles.creditCardIcon}`}
                ></icon>
              </div>
            </Card>

            <form action={process.env.REACT_APP_PAYMET_URL} method="post">
              <input
                type="hidden"
                id="MerchantId"
                name="MerchantId"
                value={process.env.REACT_APP_MERCHANTID_AULAABA}
              />
              <input
                type="hidden"
                id="MerchantName"
                name="MerchantName"
                value={process.env.REACT_APP_MERCHANT_NAME}
              />
              <input
                type="hidden"
                id="MerchantType"
                name="MerchantType"
                value={process.env.REACT_APP_MERCHANT_TYPE}
              />
              <input
                type="hidden"
                id="CurrencyCode"
                name="CurrencyCode"
                value="$"
              />
              <input
                type="hidden"
                id="OrderNumber"
                name="OrderNumber"
                value={orden.id}
              />
              <input
                type="hidden"
                id="Amount"
                name="Amount"
                value={amountToPay.replace(".", "")}
              />
              <input
                type="hidden"
                id="ITBIS"
                name="ITBIS"
                value={process.env.REACT_APP_MERCHANT_ITBIS}
              />
              <input
                type="hidden"
                id="ApprovedUrl"
                name="ApprovedUrl"
                value={ApprovedUrl}
              />
              <input
                type="hidden"
                id="DeclinedUrl"
                name="DeclinedUrl"
                value={DeclinedUrl}
              />
              <input
                type="hidden"
                id="CancelUrl"
                name="CancelUrl"
                value={CancelUrl}
              />

              <input
                type="hidden"
                id="UseCustomField1"
                name="UseCustomField1"
                value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD1}
              />
              <input
                type="hidden"
                id="CustomField1Label"
                name="CustomField1Label"
                value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD1_LABEL}
              />
              <input
                type="hidden"
                id="CustomField1Value"
                name="CustomField1Value"
                value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD1_VALUE}
              />
              <input
                type="hidden"
                id="UseCustomField2"
                name="UseCustomField2"
                value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD2}
              />
              <input
                type="hidden"
                id="CustomField2Label"
                name="CustomField2Label"
                value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD2_LABEL}
              />
              <input
                type="hidden"
                id="CustomField2Value"
                name="CustomField2Value"
                value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD2_VALUE}
              />

              <input
                type="hidden"
                id="AuthHash"
                name="AuthHash"
                value={GetHashCursos(
                  orden.id,
                  amountToPay,
                  CancelUrl,
                  ApprovedUrl,
                  DeclinedUrl
                )}
              />
              <div
                style={{
                  display: "flex",
                  gap: "3%",
                  marginTop: "3%",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  className={styles.cardBackButton}
                  label="Regresar"
                  onClick={() => stepperRef.current.prevCallback()}
                />
                <Button
                  className={styles.buttonPay}
                  label="Continuar"
                // onClick={() => stepperRef.current.nextCallback()}
                />
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};
export default CreditCardPayment;
